'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import adminRoutes from '@docpace/shared-react-routes/adminRoutes'

export function AdminIndex() {
    const router = useRouter()
    useEffect(() => {
        router?.replace(adminRoutes.Home.hrefNext())
    }, [router])
    return <></>
}

export default AdminIndex
